import React from "react";
import stylesV2 from "./TrustBuildCard.module.scss";
import stylesV3 from "./TrustBuildCardV3.module.scss";
//import cx from "classnames";
import heart from "images/Heart.png";
import star from "images/Star-new.png";
import trophy from "images/Trophy.svg";
import starSvg from "images/Star-new.svg";
import { useSchedulingABVariant } from "../utils/useSchedulingABVariant";

const StarOutline: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L14.9 8.6L22 9.3L16.5 14L18 21L12 17.5L6 21L7.5 14L2 9.3L9.1 8.6L12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="white"/>
  </svg>
);

const TrophyOutline: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 21H16M12 17V21M6 4H18V8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8V4ZM6 8H4C4 10.2091 5.79086 12 8 12M18 8H20C20 10.2091 18.2091 12 16 12M6 4H18V4C18 2.89543 17.1046 2 16 2H8C6.89543 2 6 2.89543 6 4V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export const TrustBuildCard: React.FC = () => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  const isMobile = window.innerWidth <= 992;
  const useOutlines = isV3 && isMobile;

  const starIcon = useOutlines
    ? <StarOutline className={styles.icon} />
    : <img src={starSvg} alt="" className={styles.icon} />;

  const trophyIcon = useOutlines
    ? <TrophyOutline className={styles.iconTrophy} />
    : <img src={trophy} alt="" className={styles.iconTrophy} />;

  return (
    <>
      <div className={styles.container}>
        <div className={styles.title}>The MyEyeDr. Difference</div>
        <div className={styles.list}>
          {starIcon}
          100,000+ Five-Star Reviews
        </div>
        <div className={styles.listTrophy}>
          {trophyIcon}
          Award-Winning Optometrists
        </div>
      </div>
    </>
  );
};